var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmartphone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 27,
  viewBox: "0 0 20 27"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#2f2f2f;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4 -1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 25,
  className: "a",
  rx: 2,
  transform: "translate(5 2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 22",
  className: "a"
}))));
export default SvgSmartphone;